var map = {
	"./service-video-1.png": "BXOV",
	"./service-video-2.png": "EX52",
	"./service-video-3.png": "xNvU",
	"./service-video-4.png": "ZB86",
	"./service-video-5.png": "5NSF",
	"./service-video-6.png": "nycK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zjrh";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/service\-video\-.*\.png$
// module id = zjrh
// module chunks = 1